import { memoGeneric } from '@/js/libs/memo/index.ts';

import { TabsGroupWrapper } from './styled.ts';
import { TabsGroupContent } from './TabsGroupContent.tsx';
import type { TabsGroupProps } from './types.ts';

export const TabsGroup = memoGeneric(function TabsGroup<TItem extends string = string>(props: TabsGroupProps<TItem>) {
  return (
    <TabsGroupWrapper>
      <TabsGroupContent {...props} />
    </TabsGroupWrapper>
  );
});
